import { Link } from "react-router-dom";
import { Billing } from "../models/billingModel.v2";
import { useMediaQuery } from "react-responsive";
import clsx from "clsx";
import * as FileUtils from "src/util/FileUtil";

type Columns<T> = {
  title: string;
  field: keyof T;
  value: (props: { value: any }) => JSX.Element | Promise<JSX.Element>;
};

const billingColumns: Columns<Billing>[] = [
  {
    title: "Invoice Number",
    field: "invoiceNumber",
    value: (props: any) => {
            const isMobileView = useMediaQuery({ query: "(max-width: 900px)" });
            return (
              <div
                className={
                  isMobileView
                    ? "m-0 p-0 d-flex justify-content-end"
                    : "m-0 p-0 h-auto d-flex align-items-center justify-content-start fw-bolder"
                }
              >
                {props.value}
              </div>
            );
          },
  },
  {
    title: "Invoice Date",
    field: "invoiceDate",
    value: ({ value }) => <span>{value.toDate().toLocaleDateString()}</span>,
  },
  {
    title: "Status",
    field: "status",
    value: ({ value }) => <span>{value}</span>,
  },
  {
    title: "Grand Total",
    field: "grandTotal",
    value: ({ value }) => <span>${value.toFixed(2)}</span>,
  },
  {
    title: "",
    field: "fileURL",
    value: (props: any) => {
            const value = props.value;
            const isUrl = FileUtils.isURL(value);

            const isMobileView = useMediaQuery({ query: "(max-width: 900px)" });
            return (
              <div
                className={clsx("m-0 p-0 d-flex", {
                  "justify-content-end": isMobileView,
                  "h-auto align-items-center justify-content-start fw-bolder": !isMobileView,
                }) 
                }
              >
                
                {
                //if the value is a valid URL, show the download button
                //if not a URL but a valid internal file path, button download for internal file
                // if not a valid URL or internal file path, show unclickable button that says still generating
                isUrl || FileUtils.isInternalFilePath(value) ? (
                  <a
                    href={isUrl ? value : `/files/${value}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary btn-sm"
                    download
                  >
                    Download
                  </a>
                ) : (
                  <span className="text-warning">Creating...</span>
                )}
              </div>
            );
          },
  },


];

export default billingColumns;